import React from 'react';
import * as PropTypes from 'prop-types';
import { Button } from '@si-armes/dsfr-react';

const BoutonArmePerdueVolee = ({ fermerModaleInfo, ouvrirModalePerteVol, armesSelectionnees }) => {
    let display = true;

    if (armesSelectionnees) {
        armesSelectionnees.forEach((element) => {
            if (element.statutId !== 1) {
                display = false;
            }
        });
    }

    const ouvrirModale = () => {
        ouvrirModalePerteVol();
        fermerModaleInfo();
    };

    if (!display) {
        return null;
    }

    return (
        <>
            <Button variant="primary" onClick={ouvrirModale}>
                Signaler perte/vol
            </Button>
        </>
    );
};

BoutonArmePerdueVolee.propTypes = {
    fermerModaleInfo: PropTypes.func.isRequired,
    ouvrirModalePerteVol: PropTypes.func.isRequired,
    armesSelectionnees: PropTypes.array.isRequired,
};

export default BoutonArmePerdueVolee;
